import styled, { css } from "styled-components"
import SearchResult from "./search-result"
const Popover = css`
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  z-index: 2;
  right: 0;
  top: 100%;
  margin-top: 0.5em;
  width: 65vw;
  max-width: 250px;
  padding: 1em;
  border-radius: 2px;
  background: ${({ theme }) => theme.background};
`
export default styled(SearchResult)`
  display: ${props => (props.show ? `block` : `none`)};
  ${Popover}
  .HitCount {
    display: flex;
    justify-content: flex-end;
    color: ${({ theme }) => theme.foreground};
    text-transform: uppercase;
    font-size: 80%;
  }
  .Hits {
    ul {
      list-style: none;
      margin-left: 0;
    }
    li.ais-Hits-item {
      margin-bottom: 1em;
      a {
        color: ${({ theme }) => theme.titletext};
        h6 {
          margin-bottom: 0.2em;
          color: ${({ theme }) => theme.headlinetext};
        }
      }
    }
  }
  .ais-PoweredBy {
    display: flex;
    justify-content: flex-end;
    font-size: 80%;
    color: ${({ theme }) => theme.foreground}; 
    svg {
      width: 70px;
    }
  }
`